var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrintYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#f28705;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1236 -787)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1244.122 795.122)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,7.685V2h9.746V7.685",
    transform: "translate(-2.751 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.249,16.309H3.624A1.624,1.624,0,0,1,2,14.685V10.624A1.624,1.624,0,0,1,3.624,9H16.619a1.624,1.624,0,0,1,1.624,1.624v4.061a1.624,1.624,0,0,1-1.624,1.624H14.995",
    transform: "translate(-2 -3.315)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9.746,
    height: 6.497,
    transform: "translate(3.249 9.746)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 32,
    height: 32,
    transform: "translate(1236 787)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrintYellow);
export default __webpack_public_path__ + "static/media/Icon_Print_Yellow.127d49c77154bdb7b4dc90894d7df531.svg";
export { ForwardRef as ReactComponent };